function hydrateKeyframes(keyframes, readInitialValue) {
  for (var i = 0; i < keyframes.length; i++) {
    if (keyframes[i] === null) {
      keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    }
  }
  return keyframes;
}
var keyframesList = function keyframesList(keyframes) {
  return Array.isArray(keyframes) ? keyframes : [keyframes];
};
export { hydrateKeyframes, keyframesList };